import axios from 'axios';
import { setAccessToken } from '../store/slices/auth/slice.js';
import { LOGOUT } from '../utils/constants.js';
import config from '../config.js';
import { authChannel } from '../channels/authChannel.js';

let store;

export const injectStore = _store => {
  store = _store;
};

const axiosApiFreeClient = axios.create({
  baseURL: `${config.api.baseUrl}/auth`,
});

const axiosApiClient = axios.create({
  baseURL: `${config.api.baseUrl}/api`,
});

let failedRequests = [];
let isTokenRefreshing = false;

axiosApiClient.interceptors.request.use(
  async config => {
    config.headers['X-MY-CSRF'] = 'fdsasf3wdxsxa';
    const token = store.getState().auth.accessToken;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosApiFreeClient.interceptors.request.use(
  async config => {
    config.headers['X-MY-CSRF'] = 'fdsasf3wdxsxa';
    return config;
  },
  error => {
    Promise.reject(error);
  },
);

axiosApiClient.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    const status = error.response?.status;
    const originalRequestConfig = error.config;

    if (status !== 401) {
      return Promise.reject(error);
    }

    if (isTokenRefreshing) {
      return new Promise((resolve, reject) => {
        failedRequests.push({
          resolve,
          reject,
          config: originalRequestConfig,
          error: error,
        });
      });
    }

    isTokenRefreshing = true;

    try {
      const refreshResponse = await axiosApiFreeClient.post('/d/refresh-token', {}, { withCredentials: true });
      const { accessToken } = refreshResponse.data.data;
      store.dispatch(setAccessToken({ accessToken }));
      failedRequests.forEach(({ resolve, reject, config }) => {
        axiosApiClient(config)
          .then(response => resolve(response))
          .catch(error => reject(error));
      });
    } catch (error) {
      if (error.response.data?.message === 'LOCKED') {
        try {
          await new Promise(resolve => setTimeout(resolve, 2000));
          const refreshResponse = await axiosApiFreeClient.post('/d/refresh-token', {}, { withCredentials: true });
          const { accessToken } = refreshResponse.data.data;
          store.dispatch(setAccessToken({ accessToken }));
          failedRequests.forEach(({ resolve, reject, config }) => {
            axiosApiClient(config)
              .then(response => resolve(response))
              .catch(error => reject(error));
          });
        } catch (error) {
          failedRequests.forEach(({ reject, error }) => reject(error));
          authChannel.postMessage(LOGOUT);
          store.dispatch({ type: LOGOUT });
          return Promise.reject(error);
        }
      } else {
        failedRequests.forEach(({ reject, error }) => reject(error));
        authChannel.postMessage(LOGOUT);
        store.dispatch({ type: LOGOUT });
        return Promise.reject(error);
      }
    } finally {
      failedRequests = [];
      isTokenRefreshing = false;
    }

    return axiosApiClient(originalRequestConfig);
  },
);

export default axiosApiClient;
export { axiosApiFreeClient };
